import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS, INLINES} from '@contentful/rich-text-types'
import {InlineLink, Text, Timeline} from '@primer/react-brand'

import type {PrimerComponentTimeline} from '../../../lib/types/contentful'

export type ContentfulTimelineProps = {
  component: PrimerComponentTimeline
}

export function ContentfulTimeline({component}: ContentfulTimelineProps) {
  const {blocks, hasFullWidth} = component.fields

  return (
    <Timeline fullWidth={hasFullWidth}>
      {blocks.map(timelineBlock => {
        return (
          <Timeline.Item key={timelineBlock.sys.id}>
            {documentToReactComponents(timelineBlock.fields.text, {
              renderMark: {
                [MARKS.BOLD]: children => <em>{children}</em>,
              },
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => {
                  return <Text>{children}</Text>
                },
                [INLINES.HYPERLINK]: (node, children) => {
                  return <InlineLink href={node.data.uri}>{children}</InlineLink>
                },
              },
            })}
          </Timeline.Item>
        )
      })}
    </Timeline>
  )
}

try{ ContentfulTimeline.displayName ||= 'ContentfulTimeline' } catch {}